<template>
  <div>
    <!-- Page banner -->
    <Banner main-title="projects"
            main-text="Selection of personal"
            italic-text="projects"
            typewriter-id="projects"
            banner-class="banner-purple"
            :typewriter-delay="120"
            :has-scroll-indicator="true"
            class="left"/>

    <!-- Projects -->
    <div class="boxes-wrapper">
      <ProjectBox v-for="workItem in work"
                  :key="workItem.id"
                  :project="workItem"
                  @on-project-click="() => {}"
                  class="project"/>
      <ProjectBox :project="comingSoon" class="coming-soon"/>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/v2/Banner";
import ProjectBox from "@/components/partials/work/ProjectBox";
import {userVisitedProjects} from "@/setup/firebase/firebaseAnalytics";

export default {
  name: "Projects",
  components: {
    ProjectBox,
    Banner
  },
  data: () => ({
    work: [
      // {
      //   id: 3,
      //   name: 'DARE website',
      //   description: 'DARE is the portfolio of two talented architects, Jose David Herras Barros and Reem Bou Hamdan.',
      //   link: 'alink.com',
      //   techStack: [
      //     {
      //       id: 0,
      //       icon: require('../assets/img/icons/skills/ic_javascript.svg'),
      //       name: 'Nuxt.js'
      //     },
      //     {
      //       id: 1,
      //       name: 'JavaScript',
      //       icon: require('../assets/img/icons/skills/ic_javascript.svg'),
      //     },
      //     {
      //       id: 2,
      //       name: 'SCSS',
      //       icon: require('../assets/img/icons/skills/ic_sass.svg')
      //     },
      //   ],
      //   img: require('../assets/img/work/dare/dare-MacBookAir.jpg'),
      //   width: '100%'
      // },
      {
        id: 0,
        name: 'Weather App',
        description: 'A PWA developed in Vue.js, Javascript and SCSS/CSS using the OpenWeather API.',
        img: require('../assets/img/work/weatherApp/weather_app_mockup.png'),
        link: 'https://weather-web-application-dev.web.app/',
        type: 'PWA'
        // width: '35%'
      },
      // {
      //   id: 1,
      //   name: 'MovieTvCentral',
      //   img: 'https://images.unsplash.com/photo-1454165205744-3b78555e5572?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
      //   width: '40%'
      // },
      // {
      //   id: 2,
      //   name: 'Tv-show Information',
      //   img: 'https://images.unsplash.com/photo-1501163268664-3fdf329d019f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
      //   width: '45%'
      // },
      // {
      //   id: 4,
      //   name: 'VWS',
      //   img: 'https://images.unsplash.com/photo-1563253746-350a0a877afa?ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80',
      //   width: '70%'
      // },
      // {
      //   id: 5,
      //   name: 'Project 2',
      //   img: 'https://images.unsplash.com/photo-1548611635-b6e7827d7d4a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80',
      //   width: '30%'
      // },
      // {
      //   id: 6,
      //   name: 'Project 6',
      //   img: 'https://images.unsplash.com/photo-1551739440-5dd934d3a94a?ixlib=rb-1.2.1&auto=format&fit=crop&w=700&q=80',
      //   width: '60%'
      // },
      // {
      //   id: 7,
      //   name: 'Project 8',
      //   img: 'https://images.unsplash.com/flagged/photo-1551954810-43cd6aef5b1f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1490&q=80',
      //   width: '40%'
      // },
    ],
    comingSoon: {
      id: 33,
      name: 'Coming soon',
      img: 'https://images.unsplash.com/photo-1608377205700-249f4b48b180?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80',
      description: 'More web applications are coming soon!',
      type: 'Coming soon'
      // width: '65%'
    }
  }),
  mounted() {
    userVisitedProjects();
  },
  metaInfo: {
    title: 'Pertsilis',
    titleTemplate: '%s | Projects.',
    meta: [{
      name: 'description',
      content: 'Interesting personal projects that have been developed over the years. Web applications and PWAs, using Vue.js and JavaScript.'
    }]
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/base.mixins";
@import "../assets/css/base.variables";

// Projects
.boxes-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin-top: 75px;
  padding: 0 20px;

  .project {
    flex: 100%;
  }
}

@media screen and (min-width: $screen-sm) {

  // Projects
  .boxes-wrapper {

    .project {
      flex: 50%;
    }
  }
}

@media screen and (min-width: $screen-md) {
  .boxes-wrapper {
    padding: 0 10%;
  }
}

@media screen and (min-width: $screen-lg) {

  // Projects
  .boxes-wrapper {
    .project {
      flex: 25%;
    }
  }
}
</style>
